<template>
    <div>
        <apexchart type="radialBar"  :options="chartOptions" :series="series"></apexchart>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    name: 'RadialbarChart',
    components: {
        apexchart: VueApexCharts
    },
props: {
    series: {
        type: Array,
        required: true
    },
    labels: {
        type: Array,
        default: () => ['Total']
    },
    colors: {
        type: Array,
        default: () => ['#ad88f1']
    },
    generalLabel: {
        type: String,
        default: ''
    },
    isPercentage: {
        type: Boolean,
        default: false
    },
    height: {
        type: Number,
        default: 350
    }
},
computed: {
    chartOptions() {
        // Opciones comunes
        const commonOptions = {
            chart: {
                id: 'radial-bar-chart',
                offsetY: -10,
                height: this.height
            },
            labels: this.labels,
            colors: this.colors
            
        };

        // Opciones específicas para porcentaje
        const percentageOptions = {
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    dataLabels: {
                    name: {
                        fontSize: '16px',
                        fontWeight: 900,
                        offsetY: 120
                    },
                    value: {
                        offsetY: 76,
                        fontSize: '22px',
                        fontWeight: 900,
                        formatter: () => {
                                    const total = this.series.reduce((acc, value) => acc + value, 0);
                                    return `${total.toFixed(2)}%`; // Total en porcentaje con 2 decimales
                                }
                    }
                    }
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 0.15,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 65, 91]
                },
            },
            stroke: {
                dashArray: 4
            },
            labels: [this.generalLabel],
        };

        // Opciones específicas para números
        const numberOptions = {
            plotOptions: {
                radialBar: {
                    offsetY: 0,
                    startAngle: 0,
                    endAngle: 270,
                    hollow: {
                        margin: 10,
                        size: '30%',
                        background: 'transparent',
                    },
                    dataLabels: {
                        name: {
                            fontSize: '16px',
                            fontWeight: 900,
                        },
                        value: {
                            fontSize: '20px',
                            fontWeight: 900,
                            formatter: (val) => parseInt(val), // Formateo como número
                        },
                        total: {
                            show: true,
                            label: this.generalLabel,
                            fontWeight: 600,
                            formatter: () => {
                                return this.series.reduce((acc, value) => acc + value, 0); // Total en número
                            }
                        }
                    },
                    barLabels: {
                        enabled: true,
                        useSeriesColors: true,
                        offsetX: -8,
                        fontSize: '16px',
                        formatter: function(seriesName, opts) {
                            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
                        },
                    },
                }
            }
        };

        return this.isPercentage ? { ...commonOptions, ...percentageOptions } : { ...commonOptions, ...numberOptions };
    }
}


}
</script>
